import { ref, set } from "firebase/database";
import { realtimeDB } from "./Backend";

export const formatNumber=(num)=>{
    if (num >= 1000000) {
      return (num % 1000000 === 0 ? Math.floor(num / 1000000) : (num / 1000000).toFixed(2)) + "m";
    } else if (num >= 1000) {
      return (num % 1000 === 0 ? Math.floor(num / 1000) : (num / 1000).toFixed(1)) + "k";
    } else {
      return String(num);
    }
}

export const StopMediaTracks=(stream)=>{
  try {
    stream.getTracks().forEach(track => {
      track.stop();
    });
  } catch (error) {
    console.log(error)
  }

};

export const sanitizeText =(textUtils)=>{
  if (textUtils) {
      const regex = /[^a-z0-9]/gi;
      return textUtils.replace(regex,'');
  }else{
      return "";
  }
};

export const sendPairValueDataToDB=(data_path, values)=>{
  set(ref(realtimeDB, data_path), values);
};
export const sendSingleValueDataToDB=(data_path, value)=>{
  set(ref(realtimeDB, data_path), value);
};

export const trimLettersFromUserName = (userName, textView) => {
  let initials = "";
  if (userName && userName.trim() !== "") {
      const splitNames = userName.trim().split(/\s+/);
      for (let i = 0; i < splitNames.length && i < 2; i++) { // Limit loop to 2 iterations
          if (splitNames[i] !== "") {
              initials += splitNames[i].charAt(0).toUpperCase();
          }
      }
  }
  try {
    if (textView) {
      textView.textContent = initials;

      const rand = Math.floor(Math.random() * 360);
      const randColor = `hsl(${rand}, 100%, 70%)`;
    
      textView.style.backgroundColor = randColor;
    }
   
  } catch (error) {
   console.log(error); 
  }
}

export const generateRandId=()=>{
  const randNumber = Math.floor(Math.random() * 1000000);
  const alphabets = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let appendRandLetters = "";
  for(let i=0; i < 5; i++){
    const randLetter = alphabets.charAt(Math.random() * alphabets.length);
    appendRandLetters += randLetter;
  }
  const randId = `${randNumber}${appendRandLetters}`;
  return randId;
};

export const appVariables = {
    LIVE_COMMENTS: "live comments",
    // APP_URL: "http://localhost:3002",
    APP_URL: "https://horemowghana.web.app",
    FOOTER_TEXT_COLOR: "footer_text_color",
    FOOTER_BG_COLOR: "footer_bg_color",
    CLOCK_TEXT_COLOR: "clock_text_color",
    CLOCK_BG_COLOR: "clock_bg_color",
    CHANNEL_NAME_COLOR: "channel_name_color",
    FOOTER_VISIBILITY: "show_footer",
    LOGO_VISIBILITY: "show_logo",
    CHANNEL_HANDLE: "show_handle",
    PEER_VIDEO_URL: "peer_video",
    BETHEL_CALL_STARTED: "started",
    CALL_PARTICIPANTS: "peers",
    ACCEPTED_CALLS: "accepted_calls",
}

  export const EmojisSmileysAndPeople = [
    { emoji: "😀" },
    { emoji: "😃" },
    { emoji: "😄" },
    { emoji: "😁" },
    { emoji: "😆" },
    { emoji: "😅" },
    { emoji: "🤣" },
    { emoji: "😂" },
    { emoji: "🙂" },
    { emoji: "🙃" },
    { emoji: "😉" },
    { emoji: "😊" },
    { emoji: "😇" },
    { emoji: "🥰" },
    { emoji: "😍" },
    { emoji: "🥳" },
    { emoji: "😘" },
    { emoji: "😗" },
    { emoji: "☺" },
    { emoji: "😚" },
    { emoji: "😙" },
    { emoji: "😋" },
    { emoji: "😛" },
    { emoji: "😜" },
    { emoji: "😝" },
    { emoji: "🤗" },
    { emoji: "🤤" },
    { emoji: "🤩" },
    { emoji: "🤔" },
    { emoji: "🤐" },
    { emoji: "🤨" },
    { emoji: "😐" },
    { emoji: "😑" },
    { emoji: "😶" },
    { emoji: "😶‍🌫️" },
    { emoji: "😏" },
    { emoji: "😒" },
    { emoji: "🙄" },
    { emoji: "😬" },
    { emoji: "🤥" },
    { emoji: "😮‍💨" },
    { emoji: "🙂‍↔️" },
    { emoji: "🙂‍↕️" },
    { emoji: "😌" },
    { emoji: "😔" },
    { emoji: "😪" },
    { emoji: "🤤" },
    { emoji: "😴" },
    { emoji: "😷" },
    { emoji: "🤒" },
    { emoji: "🤢" },
    { emoji: "🤮" },
    { emoji: "🤧" },
    { emoji: "🥵" },
    { emoji: "🥶" },
    { emoji: "🥳" },
    { emoji: "😎" },
    { emoji: "🫣" },
    { emoji: "🧐" },
    { emoji: "😕" },
    { emoji: "😟" },
    { emoji: "☹" },
    { emoji: "😮" },
    { emoji: "😲" },
    { emoji: "😳" },
    { emoji: "🥺" },
    { emoji: "😨" },
    { emoji: "😰" },
    { emoji: "😭" },
    { emoji: "😱" },
    { emoji: "😓" },
    { emoji: "😩" },
    { emoji: "🥱" },
    { emoji: "😤" },
    { emoji: "😠" },
    { emoji: "🙈" },
    { emoji: "🙉" },
    { emoji: "🙊" },
    { emoji: "👋" },
    { emoji: "🫂" },
    { emoji: "✋" },
    { emoji: "👌" },
    { emoji: "🤘" },
    { emoji: "✌" },
    { emoji: "👈" },
    { emoji: "👉" },
    { emoji: "👆" },
    { emoji: "👇" },
    { emoji: "👍" },
    { emoji: "👎" },
    { emoji: "✊" },
    { emoji: "👊" },
    { emoji: "👏" },
    { emoji: "🙌" },
    { emoji: "👐" },
    { emoji: "🤲" },
    { emoji: "🙏" },
    { emoji: "✍" },
    { emoji: "💪" },
    { emoji: "🦵" },
    { emoji: "🦶" },
    { emoji: "👂" },
    { emoji: "👃" },
    { emoji: "🧠" },
    { emoji: "🦷" },
    { emoji: "🦴" },
    { emoji: "👀" },
    { emoji: "👁" },
    { emoji: "👅" },
    { emoji: "👄" },
    { emoji: "👶" },
    { emoji: "🧒" },
    { emoji: "👦" },
    { emoji: "👧" },
    { emoji: "🧑" },
    { emoji: "👱" },
    { emoji: "👨" },
    { emoji: "👩" },
    { emoji: "🙋" },
    { emoji: "🙋‍♂️" },
    { emoji: "🙋‍♀️" },
    { emoji: "🙆" },
    { emoji: "🙆‍♂️" },
    { emoji: "💁" },
    { emoji: "💁‍♂️" },
    { emoji: "🙋" },
    { emoji: "🙋‍♂️" },
    { emoji: "🧑‍⚕️" },
    { emoji: "👩‍⚕️" },
    { emoji: "🧑‍🎓" },
    { emoji: "👩‍🎓" },
    { emoji: "🧑‍🏫" },
    { emoji: "👩‍🏫" },
    { emoji: "🧑‍⚖️" },
    { emoji: "👩‍⚖️" },
    { emoji: "🧑‍🌾" },
    { emoji: "👩‍🌾" },
    { emoji: "🧑‍🍳" },
    { emoji: "👩‍🍳" },
    { emoji: "🧑‍🔧" },
    { emoji: "🧑‍🏭" },
    { emoji: "🧑‍💼" },
    { emoji: "👩‍💼" },
    { emoji: "🧑‍🔬" },
    { emoji: "👩‍🔬" },
    { emoji: "🧑‍💻" },
    { emoji: "🧑‍🎤" },
    { emoji: "👩‍🎤" },
    { emoji: "🧑‍✈️" },
    { emoji: "👩‍✈️" },
    { emoji: "🧑‍🚀" },
    { emoji: "🧑‍🚒" },
    { emoji: "🕵️" },
    { emoji: "💂" },
    { emoji: "👷" },
    { emoji: "👨‍👩‍👦" },
    { emoji: "👨‍👩‍👧‍👦" },
  ];
  
  export const EmojisSymbols = [
      {emoji: "🩷"},
      {emoji: "❤️"},
      {emoji: "💛"},
      {emoji: "💚"},
      {emoji: "🩵"},
      {emoji: "💙"},
      {emoji: "💜"},
      {emoji: "💝"},
      {emoji: "💔"},
      {emoji: "❤️‍🔥"},
      {emoji: "❣️"},
      {emoji: "💖"},
      {emoji: "💘"},
      {emoji: "☪️"},
      {emoji: "🅰️"},
      {emoji: "🅱️"},
      {emoji: "🅾️"},
      {emoji: "🔈"},
      {emoji: "🔕"},
      {emoji: "🔔"},
      {emoji: "📢"},
      {emoji: "🕛"},
      {emoji: "🏧"},
      {emoji: "🚯"},
      {emoji: "🚰"},
      {emoji: "♿"},
      {emoji: "🚾"},
      {emoji: "⚠️"},
      {emoji: "🚸"},
      {emoji: "⛔"},
      {emoji: "🚫"},
      {emoji: "🚳"},
      {emoji: "🚭"},
      {emoji: "🚷"},
      {emoji: "📵"},
      {emoji: "🔞"},
      {emoji: "☢️"},
      {emoji: "⬆️"},
      {emoji: "↗️"},
      {emoji: "➡️"},
      {emoji: "↘️"},
      {emoji: "⬇️"},
      {emoji: "↙️"},
      {emoji: "⬅️"},
      {emoji: "↖️"},
      {emoji: "↕️"},
      {emoji: "↔️"},
      {emoji: "↩️"},
      {emoji: "↪️"},
      {emoji: "🔄"},
      {emoji: "🛐"},
      {emoji: "▶️"},
      {emoji: "⏩"},
      {emoji: "⏭"},
      {emoji: "⏯"},
      {emoji: "⏪"},
      {emoji: "⏮"},
      {emoji: "⏸"},
      {emoji: "⏹"},
      {emoji: "⏺"},
      {emoji: "⏏️"},
      {emoji: "🎦"},
      {emoji: "📶"},
      {emoji: "📴"},
      {emoji: "♀️"},
      {emoji: "♂️"},
      {emoji: "✖️"},
      {emoji: "➕"},
      {emoji: "➖"},
      {emoji: "➗"},
      {emoji: "♾️"},
      {emoji: "❗"},
      {emoji: "❔"},
      {emoji: "〰️"},
      {emoji: "💲"},
      {emoji: "☑️"},
      {emoji: "✔️"},
      {emoji: "❌"},
      {emoji: "©️"},
      {emoji: "®️"},
      {emoji: "™️"},
      {emoji: "0️⃣"},
      {emoji: "1️⃣"},
      {emoji: "2️⃣"},
      {emoji: "3️⃣"},
      {emoji: "4️⃣"},
      {emoji: "5️⃣"},
      {emoji: "6️⃣"},
      {emoji: "7️⃣"},
      {emoji: "8️⃣"},
      {emoji: "9️⃣"},
      {emoji: "🔟"}
  ];
  
  export const EmojisFoodAndDrink = [
      {emoji: "🍏"},
      {emoji: "🍎"},
      {emoji: "🍐"},
      {emoji: "🍊"},
      {emoji: "🍋"},
      {emoji: "🍌"},
      {emoji: "🍉"},
      {emoji: "🍇"},
      {emoji: "🍓"},
      {emoji: "🍇"},
      {emoji: "🍈"},
      {emoji: "🍒"},
      {emoji: "🍑"},
      {emoji: "🥭"},
      {emoji: "🍍"},
      {emoji: "🥥"},
      {emoji: "🥝"},
      {emoji: "🍅"},
      {emoji: "🍆"},
      {emoji: "🥑"},
      {emoji: "🫑"},
      {emoji: "🥦"},
      {emoji: "🥬"},
      {emoji: "🌶️"},
      {emoji: "🥒"},
      {emoji: "🫒"},
      {emoji: "🌽"},
      {emoji: "🥕"},
      {emoji: "🫛"},
      {emoji: "🧄"},
      {emoji: "🧅"},
      {emoji: "🥔"},
      {emoji: "🍠"},
      {emoji: "🫚"},
      {emoji: "🥐"},
      {emoji: "🥯"},
      {emoji: "🍞"},
      {emoji: "🥖"},
      {emoji: "🥨"},
      {emoji: "🧀"},
      {emoji: "🥚"},
      {emoji: "🍳"},
      {emoji: "🧈"},
      {emoji: "🥞"},
      {emoji: "🧇"},
      {emoji: "🥓"},
      {emoji: "🥩"},
      {emoji: "🍗"},
      {emoji: "🍖"},
      {emoji: "🦴"},
      {emoji: "🌭"},
      {emoji: "🍔"},
      {emoji: "🍟"},
      {emoji: "🍕"},
      {emoji: "🫓"},
      {emoji: "🥪"},
      {emoji: "🥙"},
      {emoji: "🧆"},
      {emoji: "🌮"},
      {emoji: "🌯"},
      {emoji: "🫔"},
      {emoji: "🥗"},
      {emoji: "🥘"},
      {emoji: "🫕"},
      {emoji: "🥫"},
      {emoji: "🫙"},
      {emoji: "🍝"},
      {emoji: "🍜"},
      {emoji: "🍲"},
      {emoji: "🍛"},
      {emoji: "🍣"},
      {emoji: "🍱"},
      {emoji: "🥟"},
      {emoji: "🦪"},
      {emoji: "🍤"},
      {emoji: "🍙"},
      {emoji: "🍚"},
      {emoji: "🍘"},
      {emoji: "🍥"},
      {emoji: "🥠"},
      {emoji: "🥮"},
      {emoji: "🍢"},
      {emoji: "🍡"},
      {emoji: "🍧"},
      {emoji: "🍨"},
      {emoji: "🍦"},
      {emoji: "🥧"},
      {emoji: "🧁"},
      {emoji: "🍰"},
      {emoji: "🎂"},
      {emoji: "🍮"},
      {emoji: "🍭"},
      {emoji: "🍬"},
      {emoji: "🍫"},
      {emoji: "🍿"},
      {emoji: "🍩"},
      {emoji: "🍪"},
      {emoji: "🌰"},
      {emoji: "🥜"},
      {emoji: "🫘"},
      {emoji: "🍯"},
      {emoji: "🥛"},
      {emoji: "🫗"},
      {emoji: "🍼"},
      {emoji: "🫖"},
      {emoji: "☕"},
      {emoji: "🍵"},
      {emoji: "🧃"},
      {emoji: "🥤"},
      {emoji: "🧋"},
      {emoji: "🍶"},
      {emoji: "🍺"},
      {emoji: "🍻"},
      {emoji: "🥂"},
      {emoji: "🍷"},
      {emoji: "🥃"},
      {emoji: "🍸"},
      {emoji: "🍹"},
      {emoji: "🧉"},
      {emoji: "🍾"},
      {emoji: "🧊"},
      {emoji: "🥄"},
      {emoji: "🍴"},
      {emoji: "🍽️"},
      {emoji: "🥣"},
      {emoji: "🥡"},
      {emoji: "🥢"},
      {emoji: "🧂"}
  ];
  
  export const EmojisAnimalsAndNature = [
      {emoji: "🐶"},
      {emoji: "🐱"},
      {emoji: "🐭"},
      {emoji: "🐹"},
      {emoji: "🐰"},
      {emoji: "🦊"},
      {emoji: "🐻"},
      {emoji: "🐼"},
      {emoji: "🐻‍❄️"},
      {emoji: "🐨"},
      {emoji: "🐯"},
      {emoji: "🦁"},
      {emoji: "🐮"},
      {emoji: "🐷"},
      {emoji: "🐽"},
      {emoji: "🐸"},
      {emoji: "🐵"},
      {emoji: "🙈"},
      {emoji: "🙉"},
      {emoji: "🙊"},
      {emoji: "🐒"},
      {emoji: "🐔"},
      {emoji: "🐧"},
      {emoji: "🐦"},
      {emoji: "🐤"},
      {emoji: "🐣"},
      {emoji: "🐥"},
      {emoji: "🪿"},
      {emoji: "🦆"},
      {emoji: "🐦‍⬛"},
      {emoji: "🦅"},
      {emoji: "🦉"},
      {emoji: "🦇"},
      {emoji: "🐺"},
      {emoji: "🐗"},
      {emoji: "🐴"},
      {emoji: "🦄"},
      {emoji: "🫎"},
      {emoji: "🐝"},
      {emoji: "🪱"},
      {emoji: "🐛"},
      {emoji: "🦋"},
      {emoji: "🐌"},
      {emoji: "🐞"},
      {emoji: "🐜"},
      {emoji: "🪰"},
      {emoji: "🪲"},
      {emoji: "🪳"},
      {emoji: "🦟"},
      {emoji: "🦗"},
      {emoji: "🕷️"},
      {emoji: "🕸️"},
      {emoji: "🦂"},
      {emoji: "🐢"},
      {emoji: "🐍"},
      {emoji: "🦎"},
      {emoji: "🦖"},
      {emoji: "🦕"},
      {emoji: "🐙"},
      {emoji: "🦑"},
      {emoji: "🪼"},
      {emoji: "🦐"},
      {emoji: "🦞"},
      {emoji: "🦀"},
      {emoji: "🐡"},
      {emoji: "🐠"},
      {emoji: "🐟"},
      {emoji: "🐬"},
      {emoji: "🐳"},
      {emoji: "🐋"},
      {emoji: "🦈"},
      {emoji: "🦭"},
      {emoji: "🐊"},
      {emoji: "🐅"},
      {emoji: "🐆"},
      {emoji: "🦓"},
      {emoji: "🦍"},
      {emoji: "🦧"},
      {emoji: "🦣"},
      {emoji: "🐘"},
      {emoji: "🦛"},
      {emoji: "🦏"},
      {emoji: "🐪"},
      {emoji: "🐫"},
      {emoji: "🦒"},
      {emoji: "🦘"},
      {emoji: "🦬"},
      {emoji: "🐃"},
      {emoji: "🐂"},
      {emoji: "🐄"},
      {emoji: "🫏"},
      {emoji: "🐎"},
      {emoji: "🐖"},
      {emoji: "🐏"},
      {emoji: "🐑"},
      {emoji: "🦙"},
      {emoji: "🐐"},
      {emoji: "🦌"},
      {emoji: "🐕"},
      {emoji: "🐩"},
      {emoji: "🦮"},
      {emoji: "🐕‍🦺"},
      {emoji: "🐈"},
      {emoji: "🐈‍⬛"},
      {emoji: "🪶"},
      {emoji: "🪽"},
      {emoji: "🐓"},
      {emoji: "🦃"},
      {emoji: "🦤"},
      {emoji: "🦚"},
      {emoji: "🦜"},
      {emoji: "🦢"},
      {emoji: "🦩"},
      {emoji: "🕊️"},
      {emoji: "🐇"},
      {emoji: "🦝"},
      {emoji: "🦨"},
      {emoji: "🦡"},
      {emoji: "🦫"},
      {emoji: "🦦"},
      {emoji: "🦥"},
      {emoji: "🐁"},
      {emoji: "🐀"},
      {emoji: "🐿️"},
      {emoji: "🦔"},
      {emoji: "🐾"},
      {emoji: "🐉"},
      {emoji: "🐲"},
      {emoji: "🌵"},
      {emoji: "🎄"},
      {emoji: "🌲"},
      {emoji: "🌳"},
      {emoji: "🌴"},
      {emoji: "🪵"},
      {emoji: "🌱"},
      {emoji: "🌿"},
      {emoji: "☘️"},
      {emoji: "🍀"},
      {emoji: "🎍"},
      {emoji: "🪴"},
      {emoji: "🎋"},
      {emoji: "🍃"},
      {emoji: "🍂"},
      {emoji: "🍁"},
      {emoji: "🪺"},
      {emoji: "🪹"},
      {emoji: "🍄"},
      {emoji: "🐚"},
      {emoji: "🪸"},
      {emoji: "🪨"},
      {emoji: "🌾"},
      {emoji: "💐"},
      {emoji: "🌷"},
      {emoji: "🌹"},
      {emoji: "🥀"},
      {emoji: "🪻"},
      {emoji: "🪷"},
      {emoji: "🌺"},
      {emoji: "🌸"},
      {emoji: "🌼"},
      {emoji: "🌻"},
      {emoji: "🌞"},
      {emoji: "🌝"},
      {emoji: "🌛"},
      {emoji: "🌜"},
      {emoji: "🌚"},
      {emoji: "🌕"},
      {emoji: "🌖"},
      {emoji: "🌗"},
      {emoji: "🌘"},
      {emoji: "🌑"},
      {emoji: "🌒"},
      {emoji: "🌓"},
      {emoji: "🌔"},
      {emoji: "🌙"},
      {emoji: "🌎"},
      {emoji: "🌍"},
      {emoji: "🌏"},
      {emoji: "🪐"},
      {emoji: "💫"},
      {emoji: "⭐"},
      {emoji: "🌟"},
      {emoji: "✨"},
      {emoji: "⚡"},
      {emoji: "☄️"},
      {emoji: "💥"},
      {emoji: "🔥"},
      {emoji: "🌪️"},
      {emoji: "🌈"},
      {emoji: "☀️"},
      {emoji: "🌤️"},
      {emoji: "⛅"},
      {emoji: "🌥️"},
      {emoji: "☁️"},
      {emoji: "🌦️"},
      {emoji: "🌧️"},
      {emoji: "⛈️"},
      {emoji: "🌩️"},
      {emoji: "🌨️"},
      {emoji: "❄️"},
      {emoji: "☃️"},
      {emoji: "⛄"},
      {emoji: "🌬️"},
      {emoji: "💨"},
      {emoji: "💧"},
      {emoji: "💦"},
      {emoji: "🫧"},
      {emoji: "☔"},
      {emoji: "☂️"},
      {emoji: "🌊"},
      {emoji: "🌫️"}
  ];
  
  export const EmojisActivities = [
      {emoji: "⚽"},
      {emoji: "🏀"},
      {emoji: "🏈"},
      {emoji: "⚾"},
      {emoji: "🥎"},
      {emoji: "🎾"},
      {emoji: "🏐"},
      {emoji: "🏉"},
      {emoji: "🥏"},
      {emoji: "🎱"},
      {emoji: "🪀"},
      {emoji: "🏓"},
      {emoji: "🏸"},
      {emoji: "🏒"},
      {emoji: "🏑"},
      {emoji: "🥍"},
      {emoji: "🏏"},
      {emoji: "🪃"},
      {emoji: "🥅"},
      {emoji: "⛳"},
      {emoji: "🪁"},
      {emoji: "🛝"},
      {emoji: "🏹"},
      {emoji: "🎣"},
      {emoji: "🤿"},
      {emoji: "🥊"},
      {emoji: "🥋"},
      {emoji: "🎽"},
      {emoji: "🛹"},
      {emoji: "🛼"},
      {emoji: "🛷"},
      {emoji: "⛸️"},
      {emoji: "🥌"},
      {emoji: "🎿"},
      {emoji: "⛷️"},
      {emoji: "🏂"},
      {emoji: "🪂"},
      {emoji: "🏋️‍♀️"},
      {emoji: "🏋️‍♂️"},
      {emoji: "🤼‍♀️"},
      {emoji: "🤼‍♂️"},
      {emoji: "🤸‍♀️"},
      {emoji: "🤸"},
      {emoji: "🤸‍♂️"},
      {emoji: "⛹️‍♀️"},
      {emoji: "⛹️"},
      {emoji: "⛹️‍♂️"},
      {emoji: "🤺"},
      {emoji: "🤾‍♀️"},
      {emoji: "🤾"},
      {emoji: "🤾‍♂️"},
      {emoji: "🏌️‍♀️"},
      {emoji: "🏌️"},
      {emoji: "🏌️‍♂️"},
      {emoji: "🏇"},
      {emoji: "🧘‍♀️"},
      {emoji: "🧘"},
      {emoji: "🧘‍♂️"},
      {emoji: "🏄‍♀️"},
      {emoji: "🏄"},
      {emoji: "🏄‍♂️"},
      {emoji: "🏊‍♀️"},
      {emoji: "🏊"},
      {emoji: "🏊‍♂️"},
      {emoji: "🤽‍♀️"},
      {emoji: "🤽"},
      {emoji: "🤽‍♂️"},
      {emoji: "🚣‍♀️"},
      {emoji: "🚣"},
      {emoji: "🚣‍♂️"},
      {emoji: "🧗‍♀️"},
      {emoji: "🧗"},
      {emoji: "🧗‍♂️"},
      {emoji: "🚵‍♀️"},
      {emoji: "🚵"},
      {emoji: "🚵‍♂️"},
      {emoji: "🚴‍♀️"},
      {emoji: "🚴"},
      {emoji: "🚴‍♂️"},
      {emoji: "🏆"},
      {emoji: "🥇"},
      {emoji: "🥈"},
      {emoji: "🥉"},
      {emoji: "🏅"},
      {emoji: "🎖️"},
      {emoji: "🏵️"},
      {emoji: "🎗️"},
      {emoji: "🎫"},
      {emoji: "🎟️"},
      {emoji: "🎪"},
      {emoji: "🤹‍♀️"},
      {emoji: "🤹‍♂️"},
      {emoji: "🎭"},
      {emoji: "🩰"},
      {emoji: "🎨"},
      {emoji: "🎬"},
      {emoji: "🎤"},
      {emoji: "🎧"},
      {emoji: "🎼"},
      {emoji: "🎹"},
      {emoji: "🪇"},
      {emoji: "🥁"},
      {emoji: "🪘"},
      {emoji: "🎷"},
      {emoji: "🎺"},
      {emoji: "🪗"},
      {emoji: "🎸"},
      {emoji: "🪕"},
      {emoji: "🎻"},
      {emoji: "🪈"},
      {emoji: "🎲"},
      {emoji: "♟️"},
      {emoji: "🎯"},
      {emoji: "🎳"},
      {emoji: "🎮"},
      {emoji: "🎰"},
      {emoji: "🧩"}
  ];
  
  export const EmojisTravelAndPlaces = [
      {emoji: "🚗"},
      {emoji: "🚕"},
      {emoji: "🚙"},
      {emoji: "🚌"},
      {emoji: "🚎"},
      {emoji: "🏎️"},
      {emoji: "🚓"},
      {emoji: "🚑"},
      {emoji: "🚒"},
      {emoji: "🚐"},
      {emoji: "🛻"},
      {emoji: "🚚"},
      {emoji: "🚛"},
      {emoji: "🚜"},
      {emoji: "🦯"},
      {emoji: "🦽"},
      {emoji: "🦼"},
      {emoji: "🩼"},
      {emoji: "🛴"},
      {emoji: "🚲"},
      {emoji: "🛵"},
      {emoji: "🏍️"},
      {emoji: "🛺"},
      {emoji: "🛞"},
      {emoji: "🚨"},
      {emoji: "🚔"},
      {emoji: "🚍"},
      {emoji: "🚘"},
      {emoji: "🚖"},
      {emoji: "🚡"},
      {emoji: "🚠"},
      {emoji: "🚟"},
      {emoji: "🚃"},
      {emoji: "🚋"},
      {emoji: "🚞"},
      {emoji: "🚝"},
      {emoji: "🚄"},
      {emoji: "🚅"},
      {emoji: "🚈"},
      {emoji: "🚂"},
      {emoji: "🚆"},
      {emoji: "🚇"},
      {emoji: "🚊"},
      {emoji: "🚉"},
      {emoji: "✈️"},
      {emoji: "🛫"},
      {emoji: "🛬"},
      {emoji: "🛩️"},
      {emoji: "💺"},
      {emoji: "🛰️"},
      {emoji: "🚀"},
      {emoji: "🛸"},
      {emoji: "🚁"},
      {emoji: "🛶"},
      {emoji: "⛵"},
      {emoji: "🚤"},
      {emoji: "🛥️"},
      {emoji: "🛳️"},
      {emoji: "⛴️"},
      {emoji: "🚢"},
      {emoji: "🛟"},
      {emoji: "⚓"},
      {emoji: "🪝"},
      {emoji: "⛽"},
      {emoji: "🚧"},
      {emoji: "🚦"},
      {emoji: "🚥"},
      {emoji: "🚏"},
      {emoji: "🗿"},
      {emoji: "🗺️"},
      {emoji: "🗽"},
      {emoji: "🗼"},
      {emoji: "🏰"},
      {emoji: "🏯"},
      {emoji: "🏟️"},
      {emoji: "🎡"},
      {emoji: "🎢"},
      {emoji: "🎠"},
      {emoji: "⛲"},
      {emoji: "⛱️"},
      {emoji: "🏖️"},
      {emoji: "🏝️"},
      {emoji: "🏜️"},
      {emoji: "🌋"},
      {emoji: "⛰️"},
      {emoji: "🏔️"},
      {emoji: "🗻"},
      {emoji: "🏕️"},
      {emoji: "⛺"},
      {emoji: "🛖"},
      {emoji: "🏠"},
      {emoji: "🏡"},
      {emoji: "🏘️"},
      {emoji: "🏚️"},
      {emoji: "🏗️"},
      {emoji: "🏭"},
      {emoji: "🏢"},
      {emoji: "🏬"},
      {emoji: "🏣"},
      {emoji: "🏤"},
      {emoji: "🏥"},
      {emoji: "🏦"},
      {emoji: "🏨"},
      {emoji: "🏪"},
      {emoji: "🏫"},
      {emoji: "🏩"},
      {emoji: "💒"},
      {emoji: "🏛️"},
      {emoji: "⛪"},
      {emoji: "🕌"},
      {emoji: "🕍"},
      {emoji: "🛕"},
      {emoji: "🕋"},
      {emoji: "⛩️"},
      {emoji: "🛤️"},
      {emoji: "🛣️"},
      {emoji: "🗾"},
      {emoji: "🎑"},
      {emoji: "🏞️"},
      {emoji: "🌅"},
      {emoji: "🌄"},
      {emoji: "🌠"},
      {emoji: "🎇"},
      {emoji: "🎆"},
      {emoji: "🌇"},
      {emoji: "🌆"},
      {emoji: "🏙️"},
      {emoji: "🌃"},
      {emoji: "🌌"},
      {emoji: "🌉"},
      {emoji: "🌁"}
  ];
  
  export const EmojisObjects = [
      {emoji: "⌚"},
      {emoji: "📱"},
      {emoji: "📲"},
      {emoji: "💻"},
      {emoji: "⌨️"},
      {emoji: "🖥️"},
      {emoji: "🖨️"},
      {emoji: "🖱️"},
      {emoji: "🖲️"},
      {emoji: "🕹️"},
      {emoji: "🗜️"},
      {emoji: "💽"},
      {emoji: "💾"},
      {emoji: "💿"},
      {emoji: "📀"},
      {emoji: "📷"},
      {emoji: "📼"},
      {emoji: "📸"},
      {emoji: "📹"},
      {emoji: "🎥"},
      {emoji: "📽️"},
      {emoji: "🎞️"},
      {emoji: "📞"},
      {emoji: "☎️"},
      {emoji: "📟"},
      {emoji: "📠"},
      {emoji: "📺"},
      {emoji: "📻"},
      {emoji: "🎙️"},
      {emoji: "🎚️"},
      {emoji: "🎛️"},
      {emoji: "🧭"},
      {emoji: "⏱️"},
      {emoji: "⏲️"},
      {emoji: "⏰"},
      {emoji: "🕰️"},
      {emoji: "⌛"},
      {emoji: "⏳"},
      {emoji: "📡"},
      {emoji: "🔋"},
      {emoji: "🪫"},
      {emoji: "🔌"},
      {emoji: "💡"},
      {emoji: "🔦"},
      {emoji: "🕯️"},
      {emoji: "🪔"},
      {emoji: "🧯"},
      {emoji: "🛢️"},
      {emoji: "💸"},
      {emoji: "💵"},
      {emoji: "💴"},
      {emoji: "💶"},
      {emoji: "💷"},
      {emoji: "🪙"},
      {emoji: "💰"},
      {emoji: "💳"},
      {emoji: "🪪"},
      {emoji: "💎"},
      {emoji: "⚖️"},
      {emoji: "🪜"},
      {emoji: "🧰"},
      {emoji: "🪛"},
      {emoji: "🔧"},
      {emoji: "🔨"},
      {emoji: "⚒️"},
      {emoji: "🛠️"},
      {emoji: "⛏️"},
      {emoji: "🪚"},
      {emoji: "🔩"},
      {emoji: "⚙️"},
      {emoji: "🪤"},
      {emoji: "🧱"},
      {emoji: "⛓️"},
      {emoji: "🧲"},
      {emoji: "🔫"},
      {emoji: "💣"},
      {emoji: "🧨"},
      {emoji: "🪓"},
      {emoji: "🔪"},
      {emoji: "🗡️"},
      {emoji: "⚔️"},
      {emoji: "🛡️"},
      {emoji: "🚬"},
      {emoji: "⚰️"},
      {emoji: "🪦"},
      {emoji: "⚱️"},
      {emoji: "🏺"},
      {emoji: "🔮"},
      {emoji: "📿"},
      {emoji: "🧿"},
      {emoji: "🪬"},
      {emoji: "💈"},
      {emoji: "⚗️"},
      {emoji: "🔭"},
      {emoji: "🔬"},
      {emoji: "🕳️"},
      {emoji: "🩻"},
      {emoji: "🩹"},
      {emoji: "🩺"},
      {emoji: "💊"},
      {emoji: "💉"},
      {emoji: "🩸"},
      {emoji: "🧬"},
      {emoji: "🦠"},
      {emoji: "🧪"},
      {emoji: "🧫"},
      {emoji: "🌡️"},
      {emoji: "🧹"},
      {emoji: "🪠"},
      {emoji: "🧺"},
      {emoji: "🧻"},
      {emoji: "🚽"},
      {emoji: "🚰"},
      {emoji: "🚿"},
      {emoji: "🛁"},
      {emoji: "🛀"},
      {emoji: "🧼"},
      {emoji: "🪥"},
      {emoji: "🪒"},
      {emoji: "🪮"},
      {emoji: "🧽"},
      {emoji: "🪣"},
      {emoji: "🧴"},
      {emoji: "🛎️"},
      {emoji: "🔑"},
      {emoji: "🗝️"},
      {emoji: "🚪"},
      {emoji: "🪑"},
      {emoji: "🛋️"},
      {emoji: "🛏️"},
      {emoji: "🛌"},
      {emoji: "🧸"},
      {emoji: "🪆"},
      {emoji: "🖼️"},
      {emoji: "🪞"},
      {emoji: "🪟"},
      {emoji: "🛍️"},
      {emoji: "🛒"},
      {emoji: "🎁"},
      {emoji: "🎈"},
      {emoji: "🎏"},
      {emoji: "🎀"},
      {emoji: "🪄"},
      {emoji: "🪅"},
      {emoji: "🎊"},
      {emoji: "🎉"},
      {emoji: "🎎"},
      {emoji: "🪭"},
      {emoji: "🏮"},
      {emoji: "🎐"},
      {emoji: "🪩"},
      {emoji: "🧧"},
      {emoji: "✉"},
      {emoji: "📩"},
      {emoji: "📨"},
      {emoji: "📧"},
      {emoji: "💌"},
      {emoji: "📥"},
      {emoji: "📤"},
      {emoji: "📦"},
      {emoji: "🏷️"},
      {emoji: "🪧"},
      {emoji: "📪"},
      {emoji: "📫"},
      {emoji: "📬"},
      {emoji: "📭"},
      {emoji: "📮"},
      {emoji: "📯"},
      {emoji: "📜"},
      {emoji: "📃"},
      {emoji: "📄"},
      {emoji: "📑"},
      {emoji: "🧾"},
      {emoji: "📊"},
      {emoji: "📈"},
      {emoji: "📉"},
      {emoji: "🗒️"},
      {emoji: "🗓️"},
      {emoji: "📆"},
      {emoji: "🗑️"},
      {emoji: "📇"},
      {emoji: "🗃️"},
      {emoji: "🗳️"},
      {emoji: "🗄️"},
      {emoji: "📋"},
      {emoji: "📁"},
      {emoji: "🗂️"},
      {emoji: "🗞️"},
      {emoji: "📰"},
      {emoji: "📓"},
      {emoji: "📔"},
      {emoji: "📕"},
      {emoji: "📗"},
      {emoji: "📘"},
      {emoji: "📙"},
      {emoji: "📚"},
      {emoji: "📖"},
      {emoji: "🔖"},
      {emoji: "🧷"},
      {emoji: "🔗"},
      {emoji: "📎"},
      {emoji: "🖇️"},
      {emoji: "📐"},
      {emoji: "📏"},
      {emoji: "🧮"},
      {emoji: "📌"},
      {emoji: "📍"},
      {emoji: "✂️"},
      {emoji: "🖊️"},
      {emoji: "🖋️"},
      {emoji: "✒️"},
      {emoji: "🖌️"},
      {emoji: "🖍️"},
      {emoji: "📝"},
      {emoji: "✏️"},
      {emoji: "🔍"},
      {emoji: "🔎"},
      {emoji: "🔏"},
      {emoji: "🔐"},
      {emoji: "🔒"},
      {emoji: "🔓"}
  ];

  export const ColorPallete = [
    {color: "#ff4500"},
    {color: "#FFFFFF"},
    {color: "#ff0000"},
    {color: "#0251EB"},
    {color: "#0E78F9"},
    {color: "#29335c"},
    {color: "#333333"},
    {color: "#1a1a1a"},
    {color: "#282828"},
    {color: "#252a41"},
    {color: "#222222"},
    {color: "#ff6347"}, // Tomato 
    {color: "#008080"}, // Teal 
    {color: "#ffd700"}, // Gold 
    {color: "#006400"}, // Dark Green
    {color: "#ffa07a"}, // Light Salmon 
    {color: "#20b2aa"}, // Light Sea Green 
    {color: "#dda0dd"}, // Plum 
    {color: "#4682b4"}, // Steel Blue 
    {color: "#800080"}, // Purple 
    {color: "#d2691e"}, // Chocolate 
    {color: "#ff69b4"}, // Hot Pink 
    {color: "#b0c4de"}, // Light Steel Blue 
    {color: "#fafad2"}, // Light Goldenrod Yellow
  ]